import { Component, h, Prop } from '@stencil/core';
import { DateHelper } from '../../date.helper';
import { IDatePickerModel } from '../../models/date-picker.model';

@Component({
  tag: 'pnk-datepicker-inner',
  styleUrl: 'pnk-datepicker-inner.css',
})
export class PnkDatePickerInner {
  @Prop() language: string = 'it';

  @Prop() itemSize: number = 30;

  @Prop() currentMonth: Date = new Date();

  @Prop() datepickerDates: IDatePickerModel[] = [];

  @Prop() monthChange!: (date: Date) => void;

  @Prop() dateSelect!: (date: Date) => void;

  @Prop() resolveDayView!: (date: IDatePickerModel) => string;

  @Prop() approve!: () => void;

  // component used to show days grouped by weeks

  render() {
    return (
      <div>
        <div class="pnk-flex pnk-justify-center pnk-text-center">
          {DateHelper.getWeekDaysNames(this.language).map(wd => (
            <span class="pnk-flex pnk-justify-center pnk-items-center pnk-text-small pnk-font-bold pnk-text-disabled-text pnk-h-[30px] pnk-w-[30px]">{wd}</span>
          ))}
        </div>
        {DateHelper.getDaysGroupedByWeeks(this.datepickerDates).map(item => (
          <div class="pnk-flex pnk-justify-center pnk-align-middle " onClick={() => this.approve()}>
            {item.map(d => (
              <span class="pnk-text-black pnk-rounded-full pnk-text-base pnk-h-[30px] pnk-w-[30px] hover:pnk-text-white" onClick={() => this.dateSelect(d.date)}>
                {this.resolveDayView(d)}
              </span>
            ))}
          </div>
        ))}
      </div>
    );
  }
}
